import "./TD1AdminFormUI.css";

import { AppBar, Checkbox, Toolbar, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedCheckboxRHF,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import {
	TD1AdminFormheaderColumns,
	td1AdminFormInitialData,
} from "../../TD1AdminForm";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { TD1AdminFormToolbar } from "./TD1AdminFormToolbar/TD1AdminFormToolbar";


// import { Button } from "primereact/button";

// import { Toolbar } from "primereact/toolbar";












let emptyTd1Form = {
	id: null,
	heading: "",
	detail: "",
	value: null,
	xCordinates: null,
	yCordinates: null,
};

interface ITD1AdminFormDataTable {
	td1AdminFormData: (data: any) => void;
	td1AdminFormDataById: any
	editableValueChecked: boolean;
	changeEditableCheckBoxValue: (checked: boolean) => void;

	// onDataSubmit: (value: any) => void;
	// handleFormDelete: () => void;
}
export const TD1AdminFormDataTable: FC<ITD1AdminFormDataTable> = ({
	td1AdminFormData,
	td1AdminFormDataById,
	editableValueChecked,
	changeEditableCheckBoxValue,
	// onDataSubmit,
	// handleFormDelete,
}) => {
	const theme = useTheme();
	const [td1AdminForm, setTD1AdminForm] = useState<any>(
		td1AdminFormInitialData
	);
	const [selectedTD1AdminForm, setSelectedTD1AdminForm] = useState<any>(null);
	const [empStatus, setEmpStatus] = useState(emptyTd1Form);

	useEffect(() => {
		td1AdminFormData(td1AdminForm);
	}, [td1AdminForm]);

	useEffect(() => {
		if (td1AdminFormDataById) {
			setTD1AdminForm(td1AdminFormDataById);
		}
	}, [td1AdminFormDataById]);

	const findIndexById = (id: string | number | any) => {
		let index = -1;

		for (let i = 0; i < td1AdminForm.length; i++) {
			if (td1AdminForm[i].id === id) {
				index = i;
				break;
			}
		}

		return index;
	};

	const createId = () => {
		let id = "";
		let chars =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (let i = 0; i < 5; i++) {
			id += chars.charAt(Math.floor(Math.random() * chars.length));
		}

		return id;
	};

	const openNew = () => {
		// alert("new")
		let _td1AdminForm = [...td1AdminForm];
		let _empStatus: any = { ...empStatus };

		if (empStatus.id) {
			const index = findIndexById(empStatus.id);

			_td1AdminForm[index] = _empStatus;
		} else {
			_empStatus.id = createId();
			_td1AdminForm.push(_empStatus);
		}

		setTD1AdminForm(_td1AdminForm);
		setEmpStatus(emptyTd1Form);
	};

	const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		// setTD1AdminForm((prev: any) => {
		// 	const updatedData = [...prev];
		// 	updatedData[rowIndex][event.field] = field;
		// 	return updatedData;
		// });
		setTD1AdminForm((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});
	};

	const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		return "p-component p-filled input-dropdown-fields";
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		if (x.field === "heading") {
			return (
				<InputText
					value={rowData[x.field]}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					// placeholder="Write notes here"
					// className={renderErrorClass(x, row.rowIndex, rowData)}
					style={{ width: "250px" }}
				/>
			);
		}
		// else if (x.field === "value") {
		// 	return (
		// 		<InputNumber
		// 			value={rowData[x.field]}
		// 			onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
		// 			// placeholder="Write notes here"
		// 			className={renderErrorClass(x, row.rowIndex, rowData)}
		// 			placeholder={"0.00"}
		// 			minFractionDigits={2}
		// 			maxFractionDigits={2}
		// 		/>
		// 	);
		// } 
		else if (x.field === "value") {
			return (
				<div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
					<InputNumber
						value={rowData[x.field]}
						onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
						className={renderErrorClass(x, row.rowIndex, rowData)}
						placeholder={"0.00"}
						minFractionDigits={2}
						maxFractionDigits={2}
					/>
					{row.rowIndex === 0 && (
						<EnhancedCheckboxRHF
							name="editable"
							checked={editableValueChecked}
							testId="checkbox-editable-value"
							onSelectionChangeHandler={(e: boolean) => changeEditableCheckBoxValue(e)}
						/>
					)}
				</div>
			);
		}
		else if (x.field === "xCordinates") {
			return (
				<InputNumber
					value={rowData[x.field]}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					className={renderErrorClass(x, row.rowIndex, rowData)}
					placeholder={"0.00"}
					minFractionDigits={2}
					maxFractionDigits={2}
				/>
			);
		} else if (x.field === "yCordinates") {
			return (
				<InputNumber
					value={rowData[x.field]}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					className={renderErrorClass(x, row.rowIndex, rowData)}
					placeholder={"0.00"}
					minFractionDigits={2}
					maxFractionDigits={2}
				/>
			);
		} else if (x.field === "detail") {
			return (
				<InputTextarea
					value={rowData[x.field]}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					placeholder="Detail"
					className={renderErrorClass(x, row.rowIndex, rowData)}
					rows={5}
					cols={30}
				/>
			);
		}
	};

	// const handleFormSubmit = () => {
	// 	onDataSubmit(td1AdminForm);
	// };

	// const footer = () => {
	// 	return (
	// 		<AppBar
	// 			position="sticky"
	// 			color="default"
	// 			elevation={1}
	// 			data-testId={"testId"}
	// 			sx={{
	// 				backgroundColor: "#fff",
	// 				marginTop: theme.spacing(3),
	// 				boxShadow: "none",
	// 				alignItems: "center",
	// 				zIndex: 0,
	// 				position: "sticky",
	// 				bottom: 0,
	// 			}}
	// 		>
	// 			<Toolbar>
	// 				{/* <Button
	//       label="Submit"
	//       icon="pi pi-check"
	//       severity="success"
	//       type="submit"
	//       onClick={handleFormSubmit}
	//       style={{marginRight:"10px"}}
	//     /> */}
	// 				<EnhancedButtonPrimeReact
	// 					label="Submit"
	// 					type="submit"
	// 					onClickHandler={handleFormSubmit}
	// 					// icon="pi pi-check"
	// 					raised
	// 					severity={EnhancedButtonPrimeReactSeverity.Success}
	// 				/>
	// 				{/* <Button
	//       label="Delete"
	//       icon="pi pi-times"
	//       severity="danger"
	//       onClick={handleFormDelete}
	//       style={{marginLeft:"10px"}}
	//     /> */}
	// 				<EnhancedButtonPrimeReact
	// 					// icon="pi pi-trash"
	// 					label="Delete"
	// 					raised
	// 					onClickHandler={handleFormDelete}
	// 					style={{ marginLeft: "1rem" }}
	// 					severity={EnhancedButtonPrimeReactSeverity.Danger}
	// 				/>
	// 			</Toolbar>
	// 		</AppBar>
	// 	);
	// };

	return (
		<>
			<div className="card" style={{ marginTop: "3rem" }}>
				<TD1AdminFormToolbar
					openNew={openNew}
				// confirmDeleteSelected={confirmDeleteSelected}
				// onMoveUpClickHandler={onMoveUpClickHandler}
				// onMoveDownClickHandler={onMoveDownClickHandler}
				// selectedTD1AdminForm={selectedTD1AdminForm}
				/>
				<DataTable
					value={td1AdminForm}
					dataKey="id"
					showGridlines
					className="TD1AdminForm"
					editMode="cell"
					resizableColumns
					columnResizeMode="expand"
					scrollable
					// reorderableColumns
					filterDisplay="menu"
				>
					{TD1AdminFormheaderColumns && (
						<Column
							header="#"
							className="indexColumn"
							headerStyle={{ width: "3rem", justifyContent: "center" }}
							frozen
							// hidden={!showIndexColumn}
							body={(data, options) => options.rowIndex + 1}
						></Column>
					)}
					{TD1AdminFormheaderColumns.map((x: any, index: any) => {
						return (
							<Column
								key={index}
								field={x.field}
								header={x.headerName}
								headerTooltip={x.description}
								headerTooltipOptions={{ position: "top" }}
								// sortable={false}
								// resizeable={x.resizable}
								// dataType={x.type}
								align={x.align}
								alignHeader={x.headerAlign}
								// reorderable={x.disableReorder}
								// exportable={x.disableExport}
								frozen={x.frozenColumn}
								columnKey={x.field}
								style={{
									width: x.minWidth,
									fontSize: "0.875rem",
								}}
								footer={x.footer}
								body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
							/>
						);
					})}
				</DataTable>
			</div>
			{/* {footer()} */}
		</>
	);
};
